import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSecondaryLinksSEOComponent } from './app-secondary-links-seo/app-secondary-links-seo.component';

@NgModule({
  imports: [CommonModule],
  declarations: [AppSecondaryLinksSEOComponent],
  exports: [AppSecondaryLinksSEOComponent]
})
export class SEOModule {}
